import styled, { css, keyframes } from 'styled-components';

import { Card } from '../IntegrationCard/styledComponents';

const shimmer = keyframes`
  0% {
    background-position: -240px 0;
  }

  100% {
    background-position: calc(240px + 100%) 0;
  }
`;

export const LoadingStateRoot = styled.div`
  box-sizing: border-box;
  width: 100%;
`;

export const SkeletonSearchBar = styled.div`
  animation: ${shimmer} 1.6s ease-in-out infinite;
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.colors.greys.lightyMedium} 0,
    ${({ theme }) => theme.colors.greys.lighter} 120px,
    ${({ theme }) => theme.colors.greys.lightyMedium} 240px
  );
  background-size: 480px 100%;
  border-radius: 8px;
  height: 40px;
  margin-bottom: 32px;
  max-width: 400px;
  min-width: 240px;
  width: 100%;
`;

export const SkeletonSection = styled.section`
  margin-bottom: 40px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const SkeletonSectionTitle = styled.div`
  animation: ${shimmer} 1.6s ease-in-out infinite;
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.colors.greys.lightyMedium} 0,
    ${({ theme }) => theme.colors.greys.lighter} 100px,
    ${({ theme }) => theme.colors.greys.lightyMedium} 200px
  );
  background-size: 400px 100%;
  border-radius: 6px;
  height: 22px;
  margin: 0 0 20px;
  max-width: 220px;
  width: 55%;
`;

export const SkeletonCardsGrid = styled.div`
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(auto-fill, 425px);
`;

export const SkeletonDescriptionLines = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

/** Same visual shell as integration cards; hover shadow disabled while loading. */
export const IntegrationSkeletonCardShell = styled(Card).attrs({ $isClickable: false })`
  pointer-events: none;

  &:hover {
    box-shadow: 0 2px 8px rgb(0 0 0 / 6%);
  }
`;

const skeletonBlockGradient = (theme) => css`
  animation: ${shimmer} 1.6s ease-in-out infinite;
  background: linear-gradient(
    90deg,
    ${theme.colors.greys.lightyMedium} 0,
    ${theme.colors.greys.lighter} 100px,
    ${theme.colors.greys.lightyMedium} 200px
  );
  background-size: 420px 100%;
`;

export const SkeletonCardAvatar = styled.div`
  ${({ theme }) => skeletonBlockGradient(theme)}
  border-radius: 50%;
  flex-shrink: 0;
  height: 32px;
  width: 32px;
`;

export const SkeletonCardTitleLine = styled.div`
  ${({ theme }) => skeletonBlockGradient(theme)}
  border-radius: 4px;
  flex: 1;
  height: 16px;
  max-width: 180px;
`;

export const SkeletonCardLine = styled.div`
  ${({ theme }) => skeletonBlockGradient(theme)}
  border-radius: 4px;
  height: 14px;
  width: ${({ $width }) => $width ?? '100%'};
`;

/** Placeholder aligned with integration status badge size. */
export const SkeletonStatusBadge = styled.div`
  ${({ theme }) => skeletonBlockGradient(theme)}
  border-radius: 4px;
  flex-shrink: 0;
  height: 24px;
  min-height: 24px;
  width: 72px;
`;
